import { Locale } from '@frontend/common';
import { BadgeUtils } from '@frontend/components/badge';

/**
 * Build BadgeUtils at the caller's top level (not inside useMemo/useEffect).
 * BadgeUtils → requestHandlers uses useAppSelector, so it must run like a hook.
 */
export function createPlatformObjectBadgeUtils(
    id: string,
    entityType: string,
    locale: Locale | undefined,
    display: string | undefined,
    overwriteDisplayMap?: (entity: any) => string
) {
    const utils = new BadgeUtils(id, entityType, locale, display);
    return {
        resolve: utils.resolve,
        mapDisplayName: overwriteDisplayMap ?? utils.mapDisplayName
    };
}
